// Project Classification, in one place.
//
// This list previously existed in three copies — ProjectModal, DetailsDrawer and
// the automation ConditionTreeBuilder — and when Commercial was replaced by
// PropertyManagement on 2026-09-02 each copy had to be found separately. Two were
// missed for a while, which meant the UI offered a value the backend enum could
// no longer parse while hiding the one people actually needed.
//
// Index is the stored enum value. Key is the name the backend parses and what
// automation conditions match on. Label is display only.
export const CLASSIFICATIONS = [
  { index: 0, key: 'ResidentialRequest', label: 'Residential Request' },
  { index: 1, key: 'Warranty',           label: 'Warranty' },
  { index: 2, key: 'Emergency',          label: 'Emergency' },
  // Replaced Commercial, which was never used as a Classification. Same index, so
  // any existing row keeps its meaning.
  { index: 3, key: 'PropertyManagement', label: 'Property Management' },
];

export const CLASSIFICATION_LABELS = CLASSIFICATIONS.map((c) => c.label);
export const CLASSIFICATION_SELECT_OPTIONS = CLASSIFICATIONS.map((c) => ({ value: c.index, label: c.label }));
export const CLASSIFICATION_KEYS = CLASSIFICATIONS.map((c) => c.key);
